import md5 from "js-md5";

export default function toMD5(msg) {
    return md5(msg);
}
